import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 4: Own your S#!t</h1>
          <p className="white"><b>How to own your shit</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>Take accountability for your life. Adopt a mindset that focuses on how life is always happening for you, not to you. Apply this to your past, present, and future.
            </li>
            <li>Swap expectations for appreciation.
            </li>
            <li>See problems as opportunities to grow and practice changing your attitude toward one of empowerment and gratitude. You always have the power to choose your reaction. Make a choice that serves you and your greatest life.
            </li>
            <li>If something happens that requires a vent-sesh with a friend, be on high alert to make sure it does not become a habit. Every once in a while is fine, but to have that be your go-to response anytime something in life doesn’t go your way makes you a burden, not a martyr. Vent by putting pen to paper and getting that fuckery out of your head through a good old-fashioned rage-write.
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter4.js